import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandSiminnPay(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <rect x="2.4" y="2.4" width="19.2" height="19.2" rx="2" fill="#00ADF2" />
      <path
        fillRule="evenodd"
        d="M4.997 7.828h2.737c.984 0 1.781.823 1.781 1.839 0 1.015-.797 1.838-1.78 1.838H5.952v2.923h-.956v-6.6Zm.956.966h1.781v.002c.46.03.825.425.825.908a.898.898 0 0 1-.825.907v.002H5.953v-1.82Z"
        fill="#fff"
      />
      <path d="M10.49 7.856h8.935v.394H10.49v-.394Z" fill="#fff" />
      <path
        fillRule="evenodd"
        d="M14.034 10.015h-.876v.415c-.132-.149-.57-.492-1.411-.492-1.053 0-2.18.824-2.18 2.376 0 1.43 1.28 2.194 2.245 2.194.643 0 1.128-.278 1.35-.44v.365h.872v-4.418ZM13.14 11.4v1.622l-.09.092c-.22.229-.53.555-1.129.555-.562 0-1.439-.446-1.439-1.435 0-.989.75-1.453 1.416-1.453.608 0 .914.3 1.135.517.038.037.073.072.107.102Z"
        fill="#fff"
      />
      <path
        d="M14.062 16.087H4.94v.394h9.122v-.394ZM15.778 10.031h-1.003l1.912 3.957-1.106 2.503h.98l2.812-6.46h-.98l-1.237 2.855-1.378-2.855Z"
        fill="#fff"
      />
    </BaseIcon>
  );
}
